import SuspenseLoader from 'components/SuspenseLoader';
import { ComponentType, lazy, Suspense } from 'react';
import { Navigate } from 'react-router-dom';

const Loader = (Component: ComponentType) => {
  const WithSuspense = (props: object) => (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );
  WithSuspense.displayName = 'WithSuspense';
  return WithSuspense;
};

const Services = Loader(lazy(() => import('content/services')));
const IframeShift = Loader(lazy(() => import('content/services/IframeShift')));

const serviceRoutes = [
  {
    path: '',
    element: <Navigate to="list" replace />,
  },
  {
    path: 'list',
    element: <Services />,
  },
  {
    path: 'exams-consult',
    element: <IframeShift />,
  },
];

export default serviceRoutes;
